import PT from 'prop-types';
import { ActivityStyles } from './ActivityStyles';
import { ActivityBlock } from './ActivityBlock';

export const Activity = ({
  activity,
  activityResponse,
  onBlockResponseChange,
  readOnly,
  showExample,
  reviewMode,
}) => {
  if (!activity) {
    return null;
  }

  return (
    <div data-test="activity">
      <ActivityStyles>
        {activity?.blocks.map((block) => (
          <ActivityBlock
            key={block.id}
            block={block}
            activityResponseId={activityResponse?.id}
            blockResponse={activityResponse?.block_responses[block.id] || {}}
            onBlockResponseChange={onBlockResponseChange}
            readOnly={readOnly} // TODO: confirm we need all 3 of these
            showExample={showExample} // TODO: confirm we need all 3 of these
            reviewMode={reviewMode} // TODO: confirm we need all 3 of these
          />
        ))}
      </ActivityStyles>
    </div>
  );
};

Activity.propTypes = {
  activity: PT.object.isRequired,
  activityResponse: PT.object,
  onBlockResponseChange: PT.func,
  readOnly: PT.bool,
  showExample: PT.bool,
  reviewMode: PT.bool,
};

Activity.defaultProps = {
  activityResponse: null,
  onBlockResponseChange: () => {},
  readOnly: false,
  showExample: false,
  reviewMode: false,
};
